// import * as T from './types'

const mutations = {
}

export default mutations
